import { render, staticRenderFns } from "./DistributorList.vue?vue&type=template&id=4bf0dd3a&"
import script from "./DistributorList.vue?vue&type=script&lang=js&"
export * from "./DistributorList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports